
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Base URL for Forkify API (v2)
const $ba30e20475feac5a$export$923ea8233b386e99 = 'https://forkify-api.jonas.io/api/v2/recipes/';
const $ba30e20475feac5a$export$7167c830cefcb6b5 = 'c3e5580d-7f26-4b2e-ba43-a3d151d20aa5';
const $ba30e20475feac5a$export$196440f71ed9f601 = 10;
const $ba30e20475feac5a$export$d2f17d20365655cb = 10;
const $ba30e20475feac5a$export$c5d951782b774a81 = 2.5;



/**
 * Creates a timeout promise that rejects after a given number of seconds
 * Used to prevent hanging network requests
 */ const $bd02c871d9c5ba8e$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} seconds`));
        }, s * 1000);
    });
};
const $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        // Decide request type: GET or POST
        const fetchPromise = uploadData ? fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        // Race between fetch and timeout
        const res = await Promise.race([
            fetchPromise,
            $bd02c871d9c5ba8e$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        // Convert response to JSON
        const data = await res.json();
        // Handle HTTP errors (4xx / 5xx)
        if (!res.ok) throw new Error(`${data.message} (Status: ${res.status})`);
        return data;
    } catch (err) {
        // Re-throw error so controller can handle it
        throw err;
    }
};


var $1cd63cfe08530fad$exports = {};
$1cd63cfe08530fad$exports = import.meta.resolve("eyyUD");


var $af517d3060c307fe$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$af517d3060c307fe$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = '-';
    } else type = '';
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return '0';
    const numberString = number.toString();
    const entry = numberString.split('.');
    let integer = entry[0];
    let decimal;
    if (decimal == '0' && integer !== '0') return integer;
    else if (decimal == '0' && integer == '0') return '0';
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == '99' && integer !== '0') return `${integer} 99/100`;
    else if (decimal == '99' && integer == '0') return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = '999';
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split('').reverse().join(''); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split('').reverse().join('');
        let endPattern = pattern[1].split('').reverse().join('');
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split('');
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $af517d3060c307fe$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $af517d3060c307fe$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $af517d3060c307fe$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $af517d3060c307fe$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == '0') return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


class $b2d7157267813d3a$export$2e2bcd8739ae039 {
    _data;
    /**
     * Render data to DOM
     * @param {Object|Array} data - data to render
     * @param {boolean} render - if false returns markup only
     */ render(data, render = true) {
        // Guard clause: handle empty or invalid data
        if (!data || Array.isArray(data) && data.length === 0) return this.renderErrorMessage();
        // store data
        this._data = data;
        // generate HTML markup
        const markup = this._generateMarkup();
        // return markup instead of rendering (useful for updates/testing)
        if (!render) return markup;
        // clear container and render new markup
        this._clear();
        this._parent.insertAdjacentHTML('afterbegin', markup);
    }
    /**
     * Render loading spinner
     */ renderSpinner() {
        const markup = `
        <div class="spinner">
            <svg>
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports)))}#icon-loader"></use>
            </svg>
        </div>
        `;
        this._clear();
        this._parent.insertAdjacentHTML('afterbegin', markup);
    }
    /**
     * Clear parent container
     */ _clear() {
        this._parent.innerHTML = '';
    }
    /**
     * Render error message
     */ renderErrorMessage(message = this._errorMessage) {
        const markup = `
        <div class="error">
            <div>
                <svg>
                    <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports)))}#icon-smile"></use>
                </svg>
            </div>
            <p>${message}</p>
        </div>
        `;
        this._clear();
        this._parent.insertAdjacentHTML('afterbegin', markup);
    }
    /**
     * Render success message
     */ renderSuccessMessage(message = this._successMessage) {
        const markup = `
        <div class="message">
            <div>
            <svg>
                <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports)))}#icon-alert-triangle"></use>
            </svg>
            </div>
            <p>${message}</p>
        </div>
    `;
        this._clear();
        this._parent.insertAdjacentHTML('afterbegin', markup);
    }
    /**
     * Updates only changed DOM elements instead of re-rendering whole view
     */ update(data) {
        this._data = data;
        // generate new markup
        const newMarkup = this._generateMarkup();
        // convert markup to DOM fragment
        const newDom = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDom.querySelectorAll('*'));
        const curElements = Array.from(this._parent.querySelectorAll('*'));
        // compare new vs current DOM elements
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // update changed text
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue?.trim() !== '') curEl.textContent = newEl.textContent;
            // update changed attributes
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
}


/**
 * Handles Add Recipe Modal + Form Upload UI
 * Responsibilities:
 * - Open/close modal window
 * - Handle form submission
 * - Pass data to controller
 */ class $e5dc5dc5ede8bdf4$var$AddRecipeView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    // Form container (upload form)
    _parent = document.querySelector('.upload');
    // Success message after upload
    _successMessage = 'Recipe has been uploaded successfully :)';
    // Modal elements
    _window = document.querySelector('.add-recipe-window');
    _overlay = document.querySelector('.overlay');
    // Buttons
    _btnClose = document.querySelector('.btn--close-modal');
    _btnOpen = document.querySelector('.nav__btn--add-recipe');
    constructor(){
        super();
        // Bind event handlers once on initialization
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    /**
     * Toggle modal visibility (open/close)
     */ toggleWindow() {
        this._window.classList.toggle('hidden');
        this._overlay.classList.toggle('hidden');
    }
    /**
     * Open modal event handler
     */ _addHandlerShowWindow() {
        this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
    }
    /**
     * Close modal event handler (button + overlay)
     */ _addHandlerHideWindow() {
        this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
        this._overlay.addEventListener('click', this.toggleWindow.bind(this));
    }
    /**
     * Handle form submission
     * - Prevent page reload
     * - Convert form data into object
     * - Pass data to controller
     */ addHandlerUpload(handler) {
        this._parent.addEventListener('submit', function(e) {
            e.preventDefault();
            // Convert form data into key-value object
            const data = Object.fromEntries([
                ...new FormData(this)
            ]);
            // Send data to controller
            handler(data);
        });
    }
}
var $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039 = new $e5dc5dc5ede8bdf4$var$AddRecipeView();





/**
 * Recipe View
 * Responsible for rendering recipe details UI
 * and handling user interactions (bookmarks, servings)
 */ class $d14dc0f178617192$var$RecipeView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parent = document.querySelector('.recipe');
    // Default error message if no recipe is found
    _errorMessage = 'No recipes found for your query. Please try again!';
    /**
     * Handle bookmark button click
     * Delegates event to controller
     */ addHandlerAddBookmark(handler) {
        this._parent.addEventListener('click', (e)=>{
            const btn = e.target.closest('.btn--bookmark');
            if (!btn) return;
            handler();
        });
    }
    /**
     * Generate HTML markup for recipe view
     */ _generateMarkup() {
        return `
        <figure class="recipe__fig">
            <img 
            src="${this._data.image}" 
            alt="${this._data.title}" 
            class="recipe__img" 
            />

            <h1 class="recipe__title">
            <span>${this._data.title}</span>
            </h1>
        </figure>

        <div class="recipe__details">

            <!-- Cooking time -->
            <div class="recipe__info">
            <svg class="recipe__info-icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-clock"></use>
            </svg>

            <span class="recipe__info-data recipe__info-data--minutes">
                ${this._data.cookingTime}
            </span>
            <span class="recipe__info-text">minutes</span>
            </div>

            <!-- Servings -->
            <div class="recipe__info">
            <svg class="recipe__info-icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-users"></use>
            </svg>

            <span class="recipe__info-data recipe__info-data--people">
                ${this._data.servings}
            </span>
            <span class="recipe__info-text">servings</span>

            <div class="recipe__info-buttons">
                <button
                class="btn--tiny btn--decrease-servings"
                data-update-to="${this._data.servings - 1}"
                >
                <svg>
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-minus-circle"></use>
                </svg>
                </button>

                <button
                class="btn--tiny btn--increase-servings"
                data-update-to="${this._data.servings + 1}"
                >
                <svg>
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-plus-circle"></use>
                </svg>
                </button>
            </div>
            </div>

            <!-- User generated icon -->
            <div class="recipe__user-generated ${this._data.key ? '' : 'hidden'}">
            <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-user"></use>
            </svg>
            </div>

            <!-- Bookmark button -->
            <button class="btn--round btn--bookmark">
            <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-bookmark${this._data.bookmarked ? '-fill' : ''}"></use>
            </svg>
            </button>
        </div>

        <!--Ingredients -->
        <div class="recipe__ingredients">
            <h2 class="heading--2">Recipe ingredients</h2>

            <ul class="recipe__ingredient-list">
            ${this._data.ingredients.map((ing)=>this._generateIngredient(ing)).join('')}
            </ul>
        </div>

        <!--Directions -->
            <div class="recipe__directions">
                <h2 class="heading--2">How to cook it</h2>

                <p class="recipe__directions-text">
                    This recipe was carefully designed and tested by
                    <span class="recipe__publisher">
                        ${this._data.publisher}
                    </span>.
                </p>

                <a
                    class="btn--small recipe__btn"
                    href="${this._data.sourceUrl}"
                    target="_blank"
                >
                    <span>Directions</span>
                    <svg class="search__icon">
                        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-arrow-right"></use>
                    </svg>
                </a>
            </div>`;
    }
    /**
     * Generate single ingredient markup
     * (clean separation of concerns)
     */ _generateIngredient(ingredient) {
        return `
        <li class="recipe__ingredient">
            <svg class="recipe__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-check"></use>
            </svg>

            <div class="recipe__quantity">
                ${ingredient.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($af517d3060c307fe$exports)))(ingredient.quantity) : ''}
            </div>

            <div class="recipe__description">
                <span class="recipe__unit">
                    ${ingredient.unit}
                </span>
                ${ingredient.description}
            </div>
        </li>`;
    }
    /**
     * Render recipe when URL changes
     */ addHandlerRender(handler) {
        [
            'hashchange',
            'load'
        ].forEach((event)=>window.addEventListener(event, handler));
    }
    /**
     * Handle servings update buttons
     */ addHandlerUpdateServings(handler) {
        this._parent.addEventListener('click', (e)=>{
            const btn = e.target.closest('.btn--tiny');
            if (!btn) return;
            const updateTo = +btn.dataset.updateTo;
            if (updateTo > 0) handler(updateTo);
        });
    }
}
var $d14dc0f178617192$export$2e2bcd8739ae039 = new $d14dc0f178617192$var$RecipeView();


class $813cf99795e9ec97$var$SearchView {
    // Parent element (search form)
    _parent = document.querySelector('.search');
    /**
     * Get search query from input field
     * Clears input after reading value
     */ getQuery() {
        const input = this._parent.querySelector('.search__field');
        const query = input.value;
        this._clear();
        return query;
    }
    /**
     * Clear search input field
     */ _clear() {
        this._parent.querySelector('.search__field').value = '';
    }
    /**
     * Attach handler for search submit event
     * @param {Function} handler - controller callback
     */ addHandlerSearch(handler) {
        this._parent.addEventListener('submit', function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    // currently loaded recipe
    recipe: {},
    // search-related state
    search: {
        query: '',
        page: 1,
        results: [],
        resultsPerPage: (0, $ba30e20475feac5a$export$d2f17d20365655cb)
    },
    // saved bookmarked recipes
    bookmarks: []
};
/**
 * Transform API recipe response into a clean app object
 * Keeps only the fields we actually use in the UI
 */ const $0f1d4402dffacf5b$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data.data;
    return {
        title: recipe.title,
        id: recipe.id,
        image: recipe.image_url,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        servings: recipe.servings,
        // optional property: only added if exists
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f1d4402dffacf5b$export$b96725c7a035d60b = async function(id) {
    try {
        // fetch recipe data from API
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${id}?key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`);
        // normalize and store recipe
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data);
        // check if recipe exists in bookmarks
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id);
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$202b8e5cb363a0c4 = async function(query) {
    try {
        // store current query
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        // fetch search results
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}&key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`);
        // normalize results
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = data.data.recipes.map((rec)=>({
                title: rec.title,
                id: rec.id,
                image: rec.image_url,
                publisher: rec.publisher,
                // optional API key flag
                ...rec.key && {
                    key: rec.key
                }
            }));
        // reset pagination when new search happens
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$8d7f79465139ab72 = function(page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f1d4402dffacf5b$export$5e23f4642ecad5ea = function(newServings) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings = newServings;
};
const $0f1d4402dffacf5b$export$72009cc673d27d80 = function(recipe) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // mark current recipe as bookmarked
    if (recipe.id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
    // persist changes in localStorage
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$export$136048bcb9946c75 = function(id) {
    const index = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    // remove from array
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // update current recipe state
    if (id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
    // persist changes
    $0f1d4402dffacf5b$var$persistBookmarks();
};
/**
 * Save bookmarks to localStorage
 * Makes bookmarks persistent across page reloads
 */ const $0f1d4402dffacf5b$var$persistBookmarks = function() {
    localStorage.setItem('bookmarks', JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
/**
 * Initialize application state from localStorage
 * Runs once when app starts
 */ const $0f1d4402dffacf5b$var$init = function() {
    const storage = localStorage.getItem('bookmarks');
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = storage ? JSON.parse(storage) : [];
};
$0f1d4402dffacf5b$var$init();
const $0f1d4402dffacf5b$export$d660c2254e74960d = async function(newRecipe) {
    try {
        // transform ingredients from form into structured array
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith('ingredient') && entry[1]).map((entry)=>{
            const ingArr = entry[1].split(',').map((el)=>el.trim());
            // enforce correct format: quantity, unit, description
            if (ingArr.length !== 3) throw new Error('Wrong format! Use: quantity,unit,description');
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        // build recipe object for API
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        // send data to API
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`, recipe);
        // normalize and store response
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data);
        // automatically bookmark newly added recipe
        $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};








/**
 * Preview View
 * Responsible for rendering recipe preview items
 * inside search results / bookmarks list
 */ class $a68ceb92eae160df$var$PreviewView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    // NOTE: parent is usually set dynamically in parent view (results/bookmarks)
    _parent = '';
    /**
     * Generate preview markup for a single recipe item
     */ _generateMarkup() {
        const currentId = window.location.hash.slice(1);
        const isActive = this._data.id === currentId ? 'preview__link--active' : '';
        return `
        <li class="preview">
            <a 
            class="preview__link ${isActive}" 
            href="#${this._data.id}"
            >
            
            <!-- Recipe image -->
            <figure class="preview__fig">
                <img 
                src="${this._data.image}" 
                alt="${this._data.title}" 
                />
            </figure>

            <!-- Recipe data -->
            <div class="preview__data">

                <h4 class="preview__title">
                ${this._data.title}
                </h4>

                <p class="preview__publisher">
                ${this._data.publisher}
                </p>

                <!-- User generated icon -->
                <div class="preview__user-generated ${this._data.key ? '' : 'hidden'}">
                <svg>
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-user"></use>
                </svg>
                </div>

            </div>
            </a>
        </li>
        `;
    }
}
var $a68ceb92eae160df$export$2e2bcd8739ae039 = new $a68ceb92eae160df$var$PreviewView();


/**
 * Results View
 * Responsible for rendering search results list
 */ class $dddbd0b30676c4ae$var$ResultView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parent = document.querySelector('.results');
    // Error message when no results found
    _errorMessage = 'No recipes were found for your search. Please try again!';
    /**
     * Generate markup for results list
     * Uses PreviewView for each result item
     */ _generateMarkup() {
        return this._data.map((result)=>(0, $a68ceb92eae160df$export$2e2bcd8739ae039)._generateMarkup.call({
                _data: result
            })).join('');
    }
}
var $dddbd0b30676c4ae$export$2e2bcd8739ae039 = new $dddbd0b30676c4ae$var$ResultView();




/**
 * Pagination View
 * Responsible for:
 * - Rendering pagination buttons
 * - Handling page navigation clicks
 */ class $cfa940594ee109f7$var$PaginationView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parent = document.querySelector('.pagination');
    /**
     * Handle click on pagination buttons
     * Pass selected page to controller
     */ addHandlerClick(handler) {
        this._parent.addEventListener('click', (e)=>{
            const btn = e.target.closest('.btn--inline');
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    /**
     * Generate a single pagination button
     * @param {number} page - target page number
     * @param {string} type - 'prev' | 'next'
     */ _generateButton(page, type) {
        const isPrev = type === 'prev';
        return `
        <button 
            class="btn--inline pagination__btn--${type}" 
            data-goto="${page}"
        >
            ${isPrev ? `
                <svg class="search__icon">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-arrow-left"></use>
                </svg>
                <span>Page ${page}</span>
                ` : `
                <span>Page ${page}</span>
                <svg class="search__icon">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-arrow-right"></use>
                </svg>
                `}
        </button>
        `;
    }
    /**
     * Generate full pagination markup based on current state
     */ _generateMarkup() {
        const { page: page, results: results, resultsPerPage: resultsPerPage } = this._data;
        const numPages = Math.ceil(results.length / resultsPerPage);
        // Case 1: only one page → no pagination
        if (numPages <= 1) return '';
        // Case 2: first page → only next button
        if (page === 1) return this._generateButton(page + 1, 'next');
        // Case 3: last page → only prev button
        if (page === numPages) return this._generateButton(page - 1, 'prev');
        // Case 4: middle pages → both buttons
        return `
        ${this._generateButton(page - 1, 'prev')}
        ${this._generateButton(page + 1, 'next')}
    `;
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView();




/**
 * Bookmarks View
 * Responsible for rendering list of bookmarked recipes
 */ class $5d1bb7e064b2cbd1$var$BookmarksView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parent = document.querySelector('.bookmarks__list');
    // Message when no bookmarks exist
    _errorMessage = 'No bookmarks yet. Please add some!';
    /**
     * Generate full bookmarks markup
     * Uses PreviewView for each item
     */ _generateMarkup() {
        return this._data.map((bookmark)=>(0, $a68ceb92eae160df$export$2e2bcd8739ae039)._generateMarkup.call({
                _data: bookmark
            })).join('');
    }
    /**
     * Render bookmarks on page load
     */ addHandlerRender(handler) {
        window.addEventListener('load', handler);
    }
}
var $5d1bb7e064b2cbd1$export$2e2bcd8739ae039 = new $5d1bb7e064b2cbd1$var$BookmarksView();



///////////////////////////////////////
// Controller: Recipe Details
const $f50bd1f2915ed0f2$var$controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        // Show loading spinner
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderSpinner();
        // Update UI (results + bookmarks) before loading new recipe
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$8d7f79465139ab72());
        (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
        // Load recipe data
        await $0f1d4402dffacf5b$export$b96725c7a035d60b(id);
        // Render recipe
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderErrorMessage();
    }
};
///////////////////////////////////////
// Controller: Search
const $f50bd1f2915ed0f2$var$controlSearchResults = async function() {
    try {
        // Show spinner
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).renderSpinner();
        // Get search query
        const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        // Load results
        await $0f1d4402dffacf5b$export$202b8e5cb363a0c4(query);
        // Render results + pagination
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72());
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    } catch (err) {
        (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).renderErrorMessage();
    }
};
///////////////////////////////////////
// Controller: Pagination
const $f50bd1f2915ed0f2$var$controlPagination = function(goToPage) {
    // Render new page
    (0, $dddbd0b30676c4ae$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72(goToPage));
    // Update pagination buttons
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
///////////////////////////////////////
//ontroller: Servings Update
const $f50bd1f2915ed0f2$var$controlServings = function(newServings) {
    // Update servings in state
    $0f1d4402dffacf5b$export$5e23f4642ecad5ea(newServings);
    // Update UI
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
};
///////////////////////////////////////
// Controller: Bookmarks
const $f50bd1f2915ed0f2$var$controlAddBookmark = function() {
    const recipe = $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe;
    // Toggle bookmark
    if (!recipe.bookmarked) $0f1d4402dffacf5b$export$72009cc673d27d80(recipe);
    else $0f1d4402dffacf5b$export$136048bcb9946c75(recipe.id);
    // Update recipe view (icon)
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    // Render bookmarks list
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlBookmarks = function() {
    // Render bookmarks on page load
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
///////////////////////////////////////
// Controller: Add New Recipe
const $f50bd1f2915ed0f2$var$controlAddRecipe = async function(newRecipe) {
    try {
        // Show loading spinner
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSpinner();
        // Upload recipe to API
        await $0f1d4402dffacf5b$export$d660c2254e74960d(newRecipe);
        // Render new recipe
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        // Show success message
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderSuccessMessage();
        // Render updated bookmarks (auto-added)
        (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
        // Update URL without reload
        window.history.pushState(null, '', `#${$0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id}`);
        // Close modal after delay
        setTimeout(()=>{
            (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $ba30e20475feac5a$export$c5d951782b774a81) * 1000);
    } catch (err) {
        (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).renderErrorMessage(err.message);
    }
};
///////////////////////////////////////
// App Initialization
const $f50bd1f2915ed0f2$var$init = function() {
    // Load recipe on hash change / page load
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlRecipes);
    // Search
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlSearchResults);
    // Pagination
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlPagination);
    // Servings
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerUpdateServings($f50bd1f2915ed0f2$var$controlServings);
    // Bookmark
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerAddBookmark($f50bd1f2915ed0f2$var$controlAddBookmark);
    // Render stored bookmarks
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlBookmarks);
    // Add recipe
    (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).addHandlerUpload($f50bd1f2915ed0f2$var$controlAddRecipe);
    console.log('Welcome :)');
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=repo.12c39090.js.map
